import { register } from '|>/shared/vjs'
import { BaseComponent } from '../base'

import './subtitles-unavailable-tooltip.css'

/**
 * Tooltip component shown when subtitles are unavailable
 */
@register
export class SubtitlesUnavailableTooltip extends BaseComponent {
  constructor(player: any, options: any) {
    super(player, options)
  }

  override createEl() {
    const tooltipText = this.localize('subtitles_unavailable')

    const tooltip = document.createElement('div')
    tooltip.className = 'vjs-x-subtitles-unavailable-tooltip'

    const tooltipBox = document.createElement('div')
    tooltipBox.className = 'vjs-x-tooltip-box'

    const tooltipTextEl = document.createElement('span')
    tooltipTextEl.className = 'vjs-x-tooltip-text'
    tooltipTextEl.textContent = tooltipText

    tooltipBox.appendChild(tooltipTextEl)
    tooltip.appendChild(tooltipBox)

    return tooltip
  }
}

SubtitlesUnavailableTooltip.options = {
  className: 'vjs-x-subtitles-unavailable-tooltip',
}
